import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import {
  QUERY_IPAD,
  ID_ABOUT,
  ID_WORK,
  ID_PROJECTS,
  ID_CONTACT,
} from "@shared/constants";

import {
  StyledNavbar,
  NAV_BAR_HEIGHT,
  SIDE_BAR_HEIGHT,
  SIDE_BAR_EXTRA_HEIGHT,
} from "./styles";

const List = ({ onClick }) => {
  return (
    <>
      <ul>
        <li>
          <a href={`#${ID_ABOUT}`} onClick={onClick}>
            About
          </a>
        </li>
        <li>
          <a href={`#${ID_WORK}`} onClick={onClick}>
            Work
          </a>
        </li>
        <li>
          <a href={`#${ID_PROJECTS}`} onClick={onClick}>
            Projects
          </a>
        </li>
        <li>
          <a href={`#${ID_CONTACT}`} onClick={onClick}>
            Contact
          </a>
        </li>
      </ul>
      <a
        className="resume-btn"
        href="https://drive.google.com/file/d/1o337c3s27HRWAcF6n7hsRbaE7tgV_Wd1/view"
        target="_blank"
        rel="noopener noreferrer"
      >
        Resume
      </a>
    </>
  );
};

const NavBar = ({}) => {
  const [isShow, setIsShow] = useState(false);
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const prevScrollPos = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const landingSectionPos = window.innerHeight;
      if (currentScrollPos > landingSectionPos) {
        if (currentScrollPos - prevScrollPos.current < 0 && !isShow) {
          // Going up
          setIsShow(true);
        } else if (currentScrollPos - prevScrollPos.current > 0 && isShow) {
          // Go down
          setIsShow(false);
          setIsShowSidebar(false);
        }
      }
      prevScrollPos.current = window.pageYOffset;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isShow]);

  const isMobile = useMediaQuery({ query: `(max-width: ${QUERY_IPAD}px)` });

  const handleToggleMenu = () => {
    setIsShowSidebar(prev => !prev);
  };

  return (
    <StyledNavbar style={{ top: isShow ? 0 : -NAV_BAR_HEIGHT }}>
      {isMobile ? (
        <>
          <button
            className="menu-btn"
            aria-label="Menu"
            onClick={handleToggleMenu}
          >
            <span
              className={isShowSidebar ? "menu-icon toggled" : "menu-icon"}
            />
          </button>
          <aside
            style={{
              top: isShowSidebar ? -SIDE_BAR_EXTRA_HEIGHT : -SIDE_BAR_HEIGHT,
            }}
          >
            <div className="list-container-mobile">
              <List onClick={handleToggleMenu} />
            </div>
          </aside>
        </>
      ) : (
        <div className="list-container">
          <List onClick={() => {}} />
        </div>
      )}
    </StyledNavbar>
  );
};

export default NavBar;
